module.exports = __webpack_public_path__ + "img/je.1478f6e.svg";